import React, { useState } from 'react';
import { FiPlus, FiDollarSign } from 'react-icons/fi';
import HRMSidebar from '../components/HRMSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  { ref: '12', label: 'Salary', start: '02/01/2026', end: '02/28/2026', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '13,000.00', comm: '0.00', status: 'Paid' },
  { ref: '10', label: 'Salary', start: '12/01/2025', end: '12/31/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '15,000.00', comm: '0.00', status: 'Paid' },
  { ref: '9', label: 'Salary', start: '11/01/2025', end: '11/30/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '7,500.00', comm: '0.00', status: 'Paid' },
  { ref: '8', label: 'Salary', start: '10/01/2025', end: '10/31/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '8,600.00', comm: '0.00', status: 'Paid' },
  { ref: '7', label: 'Salary', start: '09/01/2025', end: '09/30/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '10,000.00', comm: '0.00', status: 'Paid' },
  { ref: '6', label: 'Salary', start: '08/01/2025', end: '08/31/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '2,200.00', comm: '0.00', status: 'Paid' },
  { ref: '13', label: 'Salary', start: '07/01/2025', end: '07/31/2025', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'BOC', amt: '5,000.00', comm: '0.00', status: 'Paid' },
  { ref: '1', label: 'Salary', start: '06/01/2024', end: '06/30/2024', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'Hang_Seng_Ba', amt: '10,000.00', comm: '0.00', status: 'Paid' },
  { ref: '2', label: 'Salary', start: '05/01/2024', end: '05/31/2024', emp: 'Wan Yee Lui', payMethod: 'Cash', bank: 'Hang_Seng_Ba', amt: '10,000.00', comm: '0.00', status: 'Paid' }
];

export default function Salaries() {
  const [data, setData] = useLocalState('salaries_data', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'ref', direction: 'desc' });

  const handleAdd = (newData) => setData([{ ...newData, status: 'Draft' }, ...data]);
  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  const sortedData = sortData(data, sortConfig);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <HRMSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiDollarSign className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Salaries ({data.length})</span>
          </div>
          <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900"><FiPlus /></button>
        </div>
        <div className="flex-1 overflow-x-auto bg-white border border-black">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer">Ref.</th>
                <th onClick={() => handleSort('emp')} className="p-2 border border-black text-left cursor-pointer">Employee</th>
                <th onClick={() => handleSort('start')} className="p-2 border border-black text-left cursor-pointer">Period</th>
                <th onClick={() => handleSort('amt')} className="p-2 border border-black text-right cursor-pointer">Amount</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50">
                  <td className="p-2 border border-black font-bold">{row.ref}</td>
                  <td className="p-2 border border-black">{row.emp}</td>
                  <td className="p-2 border border-black">{row.start} - {row.end}</td>
                  <td className="p-2 border border-black text-right font-medium">{row.amt}</td>
                  <td className="p-2 border border-black text-center"><span className="bg-green-100 px-2 py-0.5 rounded text-green-800">{row.status}</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <GenericAddModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={handleAdd} title="Add Salary" fields={[
          { name: 'ref', label: 'Reference' }, { name: 'emp', label: 'Employee' }, { name: 'start', label: 'Start Date' },
          { name: 'end', label: 'End Date' }, { name: 'amt', label: 'Amount' }
        ]} />
      </div>
    </div>
  );
}